export const CASH_STATEMENT_PAYABLE_PREFILL_KEY = 'erp:cash-statement-payable-prefill'
export const CASH_STATEMENT_PAYABLE_CREATED_EVENT = 'cash-statement-payable-created'

export function saveCashStatementPayablePrefill(payload) {
  localStorage.setItem(CASH_STATEMENT_PAYABLE_PREFILL_KEY, JSON.stringify(payload))
}

export function consumeCashStatementPayablePrefill() {
  try {
    const raw = localStorage.getItem(CASH_STATEMENT_PAYABLE_PREFILL_KEY)
    if (!raw) return null
    localStorage.removeItem(CASH_STATEMENT_PAYABLE_PREFILL_KEY)
    return JSON.parse(raw)
  } catch {
    localStorage.removeItem(CASH_STATEMENT_PAYABLE_PREFILL_KEY)
    return null
  }
}

export function notifyCashStatementPayableCreated(cashStatementTransactionId) {
  const payload = {
    type: CASH_STATEMENT_PAYABLE_CREATED_EVENT,
    cashStatementTransactionId
  }

  if (window.opener && !window.opener.closed) {
    window.opener.postMessage(payload, window.location.origin)
  }

  localStorage.setItem(
    CASH_STATEMENT_PAYABLE_CREATED_EVENT,
    JSON.stringify({ ...payload, ts: Date.now() })
  )
}
